import { IServiceResponse } from '@sravni/types/lib/sitesettings';

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type IState = IServiceResponse;

const initialState: IState = {
  menu: undefined,
  mobileMenu: undefined,
  footer: undefined,
};

const siteSettingsSlice = createSlice({
  name: 'siteSettings',
  initialState,
  reducers: {
    setSettings: (_, action: PayloadAction<IServiceResponse>) => {
      return action.payload;
    },
  },
});

const { actions, reducer } = siteSettingsSlice;

export const { setSettings } = actions;

export default reducer;
